import { useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import StylishNewTextArea from 'components/DesignSystems/New/StylishNewTextArea';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import {
  CreateNotificationFormFields,
  NotificationType,
} from 'hooks/useNotification';

const DEFAULT_MINIMUM_MESSAGE_LENGTH = 1;
export const DEFAULT_MAXIMUM_MESSAGE_LENGTH = 1000;

export const SMS_MAXIMUM_LENGTH = 160;
export const EMAIL_SUBJECT_MAXIMUM_LENGTH = 255;

const ChannelMessageInput: React.FC = () => {
  const { watch, control } = useFormContext<CreateNotificationFormFields>();
  const [activeChannel, setActiveChannel] = useState<NotificationType | null>(
    null
  );
  const selectedChannels = watch('notificationTypes') || [];

  const displayChannel =
    activeChannel && selectedChannels.includes(activeChannel)
      ? activeChannel
      : selectedChannels[0] || null;

  if (!selectedChannels.length) return null;

  return (
    <>
      {selectedChannels.length > 1 && (
        <Row className="mb-2">
          <StylishNewToggleButtonGroup
            data={selectedChannels.map((channel) => ({
              label: channel.toUpperCase(),
              value: channel,
            }))}
            selected={displayChannel}
            onChange={(value) => setActiveChannel(value as NotificationType)}
            onBlur={() => {}}
          />
        </Row>
      )}
      {selectedChannels.includes(NotificationType.EMAIL) &&
        displayChannel === NotificationType.EMAIL && (
          <>
            <Controller
              control={control}
              name="emailSubject"
              render={({ field }) => (
                <Row className="mb-2">
                  <div className="col-12 mt-2">
                    <label className="form-label">Email Subject</label>
                    <StylishNewInput
                      type="text"
                      value={field.value || ''}
                      onChange={(e) => field.onChange(e.target.value)}
                      maxLength={EMAIL_SUBJECT_MAXIMUM_LENGTH}
                      minLength={DEFAULT_MINIMUM_MESSAGE_LENGTH}
                      required
                    />
                  </div>
                </Row>
              )}
            />
            <Controller
              control={control}
              name="emailMessage"
              render={({ field }) => (
                <>
                  <Form.Label>Email Message</Form.Label>
                  <Row>
                    <div className="col-12 mt-2">
                      <StylishNewTextArea
                        value={field.value || ''}
                        onChange={(e) => field.onChange(e.target.value)}
                        maxLength={DEFAULT_MAXIMUM_MESSAGE_LENGTH}
                        minLength={DEFAULT_MINIMUM_MESSAGE_LENGTH}
                        required
                      />
                    </div>
                  </Row>
                </>
              )}
            />
          </>
        )}

      {selectedChannels.includes(NotificationType.IN_APP) &&
        displayChannel === NotificationType.IN_APP && (
          <Controller
            control={control}
            name="appMessage"
            render={({ field }) => (
              <>
                <Form.Label>In-App Message</Form.Label>
                <Row>
                  <div className="col-12 mt-2">
                    <StylishNewTextArea
                      value={field.value || ''}
                      onChange={(e) => field.onChange(e.target.value)}
                      onBlur={field.onBlur}
                      maxLength={DEFAULT_MAXIMUM_MESSAGE_LENGTH}
                      minLength={DEFAULT_MINIMUM_MESSAGE_LENGTH}
                      required
                    />
                  </div>
                </Row>
              </>
            )}
          />
        )}
      {selectedChannels.includes(NotificationType.TEAMS) &&
        displayChannel === NotificationType.TEAMS && (
          <Controller
            control={control}
            name="teamsMessage"
            render={({ field }) => (
              <>
                <Form.Label>Teams Message</Form.Label>
                <Row>
                  <div className="col-12 mt-2">
                    <StylishNewTextArea
                      value={field.value || ''}
                      onChange={(e) => field.onChange(e.target.value)}
                      onBlur={field.onBlur}
                      maxLength={DEFAULT_MAXIMUM_MESSAGE_LENGTH}
                      minLength={DEFAULT_MINIMUM_MESSAGE_LENGTH}
                      required
                    />
                  </div>
                </Row>
              </>
            )}
          />
        )}
      {selectedChannels.includes(NotificationType.SMS) &&
        displayChannel === NotificationType.SMS && (
          <Controller
            control={control}
            name="smsMessage"
            render={({ field }) => (
              <>
                <Form.Label>SMS Message</Form.Label>
                <Row>
                  <div className="col-12 mt-2">
                    <StylishNewTextArea
                      value={field.value || ''}
                      onChange={(e) => field.onChange(e.target.value)}
                      onBlur={field.onBlur}
                      maxLength={SMS_MAXIMUM_LENGTH}
                      minLength={DEFAULT_MINIMUM_MESSAGE_LENGTH}
                      required
                    />
                  </div>
                </Row>
              </>
            )}
          />
        )}
    </>
  );
};

export default ChannelMessageInput;
